// extracted by mini-css-extract-plugin
module.exports = {"form":"index1_form__3XqxA","title":"index1_title__3D_Vk","error":"index1_error__2htEV","form-control":"index1_form-control__1IzDV","button-lg":"index1_button-lg__10ILw"};